// extracted by mini-css-extract-plugin
module.exports = {"container":"JobProspectingStatusPage_container__3V5di","details":"JobProspectingStatusPage_details__1Js8o"};